import http from '@/components/utils/axiost'

let apiUrl = {
  login: 'https://gemini.ihasl.com/api/v1/hasl/ssoService/requireToken', // 登录
  // 考试
  getExamList: '/api/v1/ext/agent/exam/getExamList', // 获取考试清单
  getExamInfo: '/api/v1/ext/agent/exam/getExamInfo',
  getExamResult: '/api/v1/ext/agent/exam/getExamResult',
  getQuestionList: '/api/v1/ext/agent/exam/generateExamPaper',
  savePaperAnswers: '/api/v1/ext/agent/exam/savePaperAnswers',
  handInPaper: '/api/v1/ext/agent/exam/handInPaper',
  getExamState: '/api/v1/ext/agent/exam/getExamState',
  checkNextTime: '/api/v1/ext/agent/exam/checkNextTime',
  invalidatorCheck: '/api/v1/ext/agent/exam/invalidatorCheck',
  fiveMinCheck: '/api/v1/ext/agent/exam/fiveMinCheck',
  getInductState: '/api/v1/ext/agent/induction/getInductState',
  // wyq引用接口地址
  setSignInformation: '/api/v1/ext/agent/induction/saveSignInfo', // 保存入司签署信息总接口
  getSignInformation: '/api/v1/ext/agent/induction/getSignInfo',
  saveInCompanyImage: '/api/v1/ext/agent/induction/saveInCompanyImage', // 入司影像
  getInCompanyImage: '/api/v1/ext/agent/induction/getInCompanyImage',
  saveAgencyContract: '/api/v1/ext/agent/induction/saveAgentContract', // 代理合同
  getAgencyContract: '/api/v1/ext/agent/induction/initAgentContract', // 初始化代理合同
  // 入司基本信息
  getBaseInfo: '/api/v1/ext/agent/induction/getBaseInfo',
  saveBaseInfo: '/api/v1/ext/agent/induction/saveBaseInfo',
  getSignState: '/api/v1/ext/agent/induction/getSignState',

  // 权限管理
  // 删除角色信息-
  deleteRoleInfo: '/api/v1/ext/auth/auth/deleteRoleInfo',
  // 权限-查询菜单信息-
  getMenuInfo: '/api/v1/ext/auth/auth/getMenuInfo',
  // 获取用户角色列表-
  getRoleList: '/api/v1/ext/auth/auth/getRoleList',

  // 权限-查询角色权限-
  getRolePermission: '/api/v1/ext/auth/auth/getRolePermission',
  // 新建或者修改角色-
  saveRoleInfo: '/api/v1/ext/auth/auth/saveRoleInfo',
  // 权限-修改角色权限-
  saveRolePermission: '/api/v1/ext/auth/auth/saveRolePermission',

  // 绩效查询
  getPuserInfo: '/api/v1/ext/agent/performance/getUserBaseInfo',
  getTeamInfo: '/api/v1/ext/agent/performance/getTeamInfo',
  getTeamTree: '/api/v1/ext/agent/performance/getTeamtree',
  getPersonalAssessmentInfo: '/api/v1/ext/agent/performance/getPersonalAssessmentInfo',
  getPersonalConRate: '/api/v1/ext/agent/performance/getPersonalConRate',
  getPersonalConRateDetail: '/api/v1/ext/agent/performance/getPersonalConRateDetail',
  getTeamConRate: '/api/v1/ext/agent/performance/getTeamConRate',
  getTeamAssessment: '/api/v1/ext/agent/performance/getTeamAssessment',

  // token测试
  getToken: '/api/v1/hasl/sso/ssoService/requireToken',
  // 保单列表
  // 获取公司和
  getManageComInfo: '/api/v1/ext/policy/query/getManageComInfo',
  // 获取保单列表
  getPolicyList: '/api/v1/ext/policy/query/getPolicyList',
  getPolicyAbout: '/api/v1/ext/policy/query/getPolicyBasicInfo', // 获取保单信息
  getPersionInfo: '/api/v1/ext/policy/query/getPersonerInfo', // 获取用户信息
  getPersionHistory: '/api/v1/ext/policy/query/getPersonerHistory', // 获取用户历史
  getAccountInfo: '/api/v1/ext/policy/query/getAccountInfo', // 账户信息
  getAgentInfo: '/api/v1/ext/policy/query/getAgentInfo', // 获取营销信息
  getAgentHistory: '/api/v1/ext/policy/query/getAgentHistory', // 营销历史
  getPersonalIncome: '/api/v1/ext/agent/performance/getPersonalIncome',
  getDirTree: '/api/v1/ext/train/query/getDirTree', // 获取目录树
  getBranchtypeLst: '/api/v1/ext/train/query/getBranchtypeLst', // 获取渠道列表
  getSubDirLst: '/api/v1/ext/train/query/getSubDirLst', // 获取目录下信息
  saveDir: '/api/v1/ext/agent/train/saveDir', // 新增目录
  updateDir: '/api/v1/ext/agent/train/updateDir', // 更新目录
  getDirInfoByCode: '/api/v1/ext/train/query/getDirInfoByCode', // 通过主键获取目录信息
  delDir: '/api/v1/ext/agent/train/delDir', // 通过主键获取目录信息
  uploadTest: '/file/v1/hasl/fileAdmin/fileAdmin/upload',
  importDirAgent: '/api/v1/ext/agent/train/importDirAgent', // 导入代理人
  getAllAgent: '/api/v1/ext/train/query/getAllAgent', // 获取导入人员
  getAuthAgent: '/api/v1/ext/train/query/getAuthAgent', // 获取有权限的人员列表
  getGradeMangecomTree: '/api/v1/ext/train/query/getGradeMangecomTree', // 获取职级，机构列表
  getManageComAuthByDirCode: '/api/v1/ext/train/query/getManageComAuthByDirCode', // 保存人员，职级，机构权限
  saveManageComAuth: '/api/v1/ext/agent/train/saveManageComAuth', // 保存人员，职级，机构权限
  getCourseInfoWithPage: '/api/v1/ext/train/query/getCourseInfoWithPage', // 查询课件分页
  delCourse: '/api/v1/ext/agent/train/delCourse', // 通过课件 删除课程（含课件与课程浏览信息）
  saveCourse: '/api/v1/ext/agent/train/saveCourse', // 保存课程
  updateCourse: '/api/v1/ext/agent/train/updateCourse', // 通过课件code 更新课程（含课件，课程浏览信息，课件浏览信息）
  updateCourseInfo: '/api/v1/ext/agent/train/updateCourseInfo', // 通过课件code 更新课程（状态，是否推送）
  getCourseByCode: '/api/v1/ext/train/query/getCourseByCode', // 通过课件code 获取课程信息（含课件）
  getCourseUploaderByBranchtype: '/api/v1/ext/train/query/getCourseListByBranchtype', // 通过渠道获取上传人
  getCoursewareSummaryWithPage: '/api/v1/ext/train/query/getCoursewareSummaryWithPage', //  带分页的课件阅读查询
  getCourseSummaryWithPage: '/api/v1/ext/train/query/getCourseSummaryWithPage', // 带分页的课程阅读查询
  exportCourseSummaryExcel: '/api/v1/ext/agent/train/exportCourseSummaryExcel', // 导出课程阅读信息
  exportCoursewareSummaryExcel: '/api/v1/ext/agent/train/exportCoursewareSummaryExcel', // 导出课件阅读信息
  // 内容管理
  initPublishTypes: '/api/v1/ext/cms/content/initPublishTypes', // 初始化发布类型接口
  initVisiblePeople: '/api/v1/ext/cms/content/initVisiblePeople', // 初始化可见人员接口
  getContentList: '/api/v1/ext/cms/content/getContentList', // 获取内容列表
  publishContent: '/api/v1/ext/cms/content/publishContent', // 发布、取消发布
  deleteContent: '/api/v1/ext/cms/content/deleteContent', // 删除发布
  stickContent: '/api/v1/ext/cms/content/stickContent', // 置顶内容
  searchContent: '/api/v1/ext/cms/content/searchContent', // 搜索内容
  saveContent: '/api/v1/ext/cms/content/saveContent', // 编辑、添加内容

  cancelTiming: '/api/v1/ext/cms/content/cancelTiming', // 取消定时发布
  updatePublishTime: '/api/v1/ext/cms/content/updatePublishTime', // 修改发布时间
  previewContent: '/api/v1/ext/cms/content/previewContent', // 预览发布内容
  savePreviewContent: '/api/v1/ext/cms/content/savePreviewContent', // 预览保存富文本接口
  getContent: '/api/v1/ext/cms/content/getContent',
  initInformation: '/api/v1/ext/cms/content/initInformation', // 资讯
  // 活动量统计
  getAgentChannel: '/api/v1/ext/agent/train/getAgentChannel',
  getActivityGroupTree: '/api/v1/ext/agent/activity/getActivityGroupTree',
  exportActivityGroupSummary: '/api/v1/ext/agent/activity/exportActivityGroupSummary',
  getActivityGroupNumWithPage: '/api/v1/ext/activity/query/getActivityGroupNumWithPage',
  exportActivityGroupNum: '/api/v1/ext/agent/activity/exportActivityGroupNum',
  getCustomers: '/api/v1/ext/agent/customer/getCustomers',
  getCustomerInfo: '/api/v1/ext/agent/customer/getCustomerInfo', // 获取客户信息
  getCustomerPolicyInfo: '/api/v1/ext/agent/customer/getCustomerPolicyInfo' // 获取客户保单信息
}
export default {
  urlDomin: process.env.FILE_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/get/',
  post: function(url, options, success, error) {
    http
      .post(url, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  login: function(options, success, error) {
    http
      .post(apiUrl.login, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  // 删除角色信息
  deleteRoleInfo: function(options, success, error) {
    http
      .post(apiUrl.deleteRoleInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  importDirAgent: function(options, success, error) {
    http
      .post(apiUrl.importDirAgent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getCourseInfoWithPage: function(options, success, error) {
    http
      .post(apiUrl.getCourseInfoWithPage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getCourseUploaderByBranchtype: function(options, success, error) {
    http
      .post(apiUrl.getCourseUploaderByBranchtype, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  delCourse: function(options, success, error) {
    http
      .post(apiUrl.delCourse, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveCourse: function(options, success, error) {
    http
      .post(apiUrl.saveCourse, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  updateCourse: function(options, success, error) {
    http
      .post(apiUrl.updateCourse, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  updateCourseInfo: function(options, success, error) {
    http
      .post(apiUrl.updateCourseInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getCourseByCode: function(options, success, error) {
    http
      .post(apiUrl.getCourseByCode, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getGradeMangecomTree: function(options, success, error) {
    http
      .post(apiUrl.getGradeMangecomTree, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getManageComAuthByDirCode: function(options, success, error) {
    http
      .post(apiUrl.getManageComAuthByDirCode, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveManageComAuth: function(options, success, error) {
    http
      .post(apiUrl.saveManageComAuth, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  // 权限-查询菜单信息-
  getMenuInfo: function(options, success, error) {
    http
      .post(apiUrl.getMenuInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getBranchtypeLst: function(options, success, error) {
    http
      .post(apiUrl.getBranchtypeLst, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },

  getSubDirLst: function(options, success, error) {
    http
      .post(apiUrl.getSubDirLst, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveDir: function(options, success, error) {
    http
      .post(apiUrl.saveDir, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getDirInfoByCode: function(options, success, error) {
    http
      .post(apiUrl.getDirInfoByCode, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  updateDir: function(options, success, error) {
    http
      .post(apiUrl.updateDir, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  delDir: function(options, success, error) {
    http
      .post(apiUrl.delDir, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAllAgent: function(options, success, error) {
    http
      .post(apiUrl.getAllAgent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAuthAgent: function(options, success, error) {
    http
      .post(apiUrl.getAuthAgent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  // 获取用户角色列表-
  getRoleList: function(options, success, error) {
    http
      .post(apiUrl.getRoleList, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },

  // 权限-查询角色权限-
  getRolePermission: function(options, success, error) {
    http
      .post(apiUrl.getRolePermission, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  // 新建或者修改角色-
  saveRoleInfo: function(options, success, error) {
    http
      .post(apiUrl.saveRoleInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  // 权限-修改角色权限-
  saveRolePermission: function(options, success, error) {
    http
      .post(apiUrl.saveRolePermission, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },

  setSignInformation: function(options, success, error) {
    http
      .post(apiUrl.setSignInformation, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getBaseInfo: function(options, success, error) {
    http
      .post(apiUrl.getBaseInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveBaseInfo: function(options, success, error) {
    http
      .post(apiUrl.saveBaseInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getExamList: function(options, success, error) {
    http
      .post(apiUrl.getExamList, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getExamInfo: function(options, success, error) {
    http
      .post(apiUrl.getExamInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getExamResult: function(options, success, error) {
    http
      .post(apiUrl.getExamResult, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getQuestionList: function(options, success, error) {
    http
      .post(apiUrl.getQuestionList, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  savePaperAnswers: function(options, success, error) {
    http
      .post(apiUrl.savePaperAnswers, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  handInPaper: function(options, success, error) {
    http
      .post(apiUrl.handInPaper, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getSignState: function(options, success, error) {
    http
      .get(apiUrl.getSignState, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveInCompanyImage: function(options, success, error) {
    http
      .post(apiUrl.saveInCompanyImage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getEntryNotice: function(options, success, error) {
    http
      .post(apiUrl.getEntryNotice, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getSignInformation: function(options, success, error) {
    http
      .post(apiUrl.getSignInformation, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getExamState: function(options, success, error) {
    http
      .post(apiUrl.getExamState, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  reExam: function(options, success, error) {
    http
      .post(apiUrl.reExam, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  checkNextTime: function(options, success, error) {
    http
      .post(apiUrl.checkNextTime, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  invalidatorCheck: function(options, success, error) {
    http
      .post(apiUrl.invalidatorCheck, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  fiveMinCheck: function(options, success, error) {
    http
      .post(apiUrl.fiveMinCheck, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getInCompanyImage: function(options, success, error) {
    http
      .post(apiUrl.getInCompanyImage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveAgencyContract: function(options, success, error) {
    http
      .post(apiUrl.saveAgencyContract, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAgencyContract: function(options, success, error) {
    http
      .post(apiUrl.getAgencyContract, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getInductState: function(options, success, error) {
    http
      .post(apiUrl.getInductState, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  test: function(options, success, error) {
    http
      .post('/api/v1/hasl/ssoService/requireToken', options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getTeamAssessment: function(options, success, error) {
    http
      .post(apiUrl.getTeamAssessment, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getToken: function(options, success, error) {
    http
      .post(apiUrl.getToken, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getTeamTree: function(options, success, error) {
    http
      .post(apiUrl.getTeamTree, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getManageComInfo: function(options, success, error) {
    http
      .post(apiUrl.getManageComInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getPolicyList: function(options, success, error) {
    http
      .post(apiUrl.getPolicyList, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getPolicyAbout: function(options, success, error) {
    http
      .post(apiUrl.getPolicyAbout, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getPersionInfo: function(options, success, error) {
    http
      .post(apiUrl.getPersionInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getPersionHistory: function(options, success, error) {
    http
      .post(apiUrl.getPersionHistory, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAccountInfo: function(options, success, error) {
    http
      .post(apiUrl.getAccountInfo, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAgentHistory: function(options, success, error) {
    http
      .post(apiUrl.getAgentHistory, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getPersonalIncome: function(options, success, error) {
    http
      .post(apiUrl.getPersonalIncome, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getDirTree: function(options, success, error) {
    http
      .post(apiUrl.getDirTree, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getCourseSummaryWithPage: function(options, success, error) {
    http
      .post(apiUrl.getCourseSummaryWithPage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getCoursewareSummaryWithPage: function(options, success, error) {
    http
      .post(apiUrl.getCoursewareSummaryWithPage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  exportCourseSummaryExcel: function(options, success, error) {
    http
      .post(apiUrl.exportCourseSummaryExcel, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  exportCoursewareSummaryExcel: function(options, success, error) {
    http
      .post(apiUrl.exportCoursewareSummaryExcel, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  initPublishTypes: function(options, success, error) {
    http
      .post(apiUrl.initPublishTypes, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  initVisiblePeople: function(options, success, error) {
    http
      .post(apiUrl.initVisiblePeople, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getContentList: function(options, success, error) {
    http
      .post(apiUrl.getContentList, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  publishContent: function(options, success, error) {
    http
      .post(apiUrl.publishContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  deleteContent: function(options, success, error) {
    http
      .post(apiUrl.deleteContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  stickContent: function(options, success, error) {
    http
      .post(apiUrl.stickContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  searchContent: function(options, success, error) {
    http
      .post(apiUrl.searchContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  saveContent: function(options, success, error) {
    http
      .post(apiUrl.saveContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },

  cancelTiming: function(options, success, error) {
    http
      .post(apiUrl.cancelTiming, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  updatePublishTime: function(options, success, error) {
    http
      .post(apiUrl.updatePublishTime, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  initInformation: function(options, success, error) {
    http
      .post(apiUrl.initInformation, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  previewContent: function(options, success, error) {
    http
      .post(apiUrl.previewContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  savePreviewContent: function(options, success, error) {
    console.log(apiUrl.savePreviewContent)
    http
      .post(apiUrl.savePreviewContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getContent: function(options, success, error) {
    http
      .post(apiUrl.getContent, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getAgentChannel: function(options, success, error) {
    http
      .post(apiUrl.getAgentChannel, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getActivityGroupTree: function(options, success, error) {
    http
      .post(apiUrl.getActivityGroupTree, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  exportActivityGroupSummary: function(options, success, error) {
    http
      .post(apiUrl.exportActivityGroupSummary, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  getActivityGroupNumWithPage: function(options, success, error) {
    http
      .post(apiUrl.getActivityGroupNumWithPage, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  },
  exportActivityGroupNum: function(options, success, error) {
    http
      .post(apiUrl.exportActivityGroupNum, options)
      .then(res => {
        success && success(res)
      })
      .catch(err => {
        error && error(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api.js